import { render, staticRenderFns } from "./PlainTable.vue?vue&type=template&id=1ccfdffd&scoped=true&slot-scope=scope&"
import script from "./PlainTable.vue?vue&type=script&lang=js&"
export * from "./PlainTable.vue?vue&type=script&lang=js&"
import style0 from "./PlainTable.vue?vue&type=style&index=0&id=1ccfdffd&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ccfdffd",
  null
  
)

export default component.exports